export default __webpack_public_path__ + "static/media/package-icon.ec82147b.svg";